import React from "react";
// import Carousel from "./../carousel/carousel2";
import Carousel from "../carousel/carousel1";

function Home() {
  return <Carousel />;
}

export default Home;
